import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { SUPPLIERS_ENDPOINT } from "./constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";
import { useCurrentTrip } from "@/hooks";

type QueryError = {};

export enum JOB_STATUS {
  Active = "Active",
  Pending = "Pending",
  Placed = "Placed",
  Inactive = "Inactive",
}

export type JobType = {
  id: number;
  role: string;
  sub_role: string;
  description: string;
  no_position: string;
  skill_set: string;
  summary: string;
  start_date: string;
  partner_name: string;
  s3_logo: any;
  website: string;
  about: string;
  state: string;
  industry: string;
  is_suggested: number;
  is_saved: number;
  is_interested: number;
  order: number;
  interested_id?: number;
  saved_id?: number;
  interested_at?: number;
  post_date?: number;
  city: string;
  status: JOB_STATUS;
  _cb: number;
  category_list: string;
  salary_from: number | string;
  salary_to: number | string;
  source_url: string;
  salary_type: string;
  perk_benefit?: string;
  categories?: Array<string>;
  dates?: Array<{ start_date: number; end_date: number }>;
};

type Result = JobType;

const useJobQuery = (
  jobId: string,
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const { currentTrip } = useCurrentTrip();
  const tid = currentTrip?.id;
  const URL = `${SUPPLIERS_ENDPOINT}/jobs/${jobId}`;
  const { fetchWithAuth } = useFetchWithAuth();
  const cacheKey = [URL, tid];

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      if (!tid || !jobId) throw new Error();
      const res = await fetchWithAuth<Result>(URL, { params: { tid: tid } });
      return res;
    },
    {
      enabled: !!tid && !!jobId,
      ...options,
    }
  );
};

export default useJobQuery;
